import { Badge, HStack, Text } from "@chakra-ui/react"

interface Props {
    isActive: boolean,
    size?: string
}

const StatusIndicator = ({ isActive, size = 'md' }: Props) => {
    return (
        <HStack spacing={2} alignItems="center">
            <Badge
                backgroundColor={isActive ? "green.500" : "red.500"}
                height={size === 'md' ? "18px" : size === 'sm' ? '14px' : '18px'}
                width={size === 'md' ? "18px" : size === 'sm' ? '14px' : '18px'}
                borderRadius="full"
            ></Badge>
            <Text fontSize={size === 'md' ? "18px" : size === 'sm' ? '14px' : '18px'}>
                {isActive ? "Ativo" : "Inativo"}
            </Text>
        </HStack>
    )
}

export default StatusIndicator